var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.64012 13.1841C7.64012 14.2707 8.52097 15.1515 9.60756 15.1515C10.6941 15.1515 11.575 14.2707 11.575 13.1841C11.575 12.0975 10.6941 11.2167 9.60756 11.2167C8.52097 11.2167 7.64012 12.0975 7.64012 13.1841ZM7.64012 13.1841H5.00039C2.79133 13.1841 1.00049 11.3934 1.00039 9.1843L1 1.33334M7.27122 5.31434H1M11.575 5.31434C11.575 6.40093 10.6941 7.28178 9.60756 7.28178C8.52097 7.28178 7.64012 6.40093 7.64012 5.31434C7.64012 4.22775 8.52097 3.3469 9.60756 3.3469C10.6941 3.3469 11.575 4.22775 11.575 5.31434Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubCategory);
export default __webpack_public_path__ + "static/media/sub-category.c6d9a88c851d693f7665bac80c67f179.svg";
export { ForwardRef as ReactComponent };